/**
 * usePageTracking — automatic GA4 + Clarity page-view tracking for SPA route changes.
 *
 * Drop this hook once in your route wrapper component.
 * It fires a virtual page view on every location change.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import analytics from './analytics';

const ROUTE_NAMES = {
  '/': 'Home',
  '/about': 'About',
  '/menu': 'Menu',
  '/menutwo': 'Menu Style 2',
  '/menuthree': 'Menu Style 3',
  '/menufour': 'Menu Style 4',
  '/ourchefs': 'Our Chefs',
  '/contact': 'Contact',
  '/reservation': 'Reservation',
  '/hometwo': 'Home Style 2',
  '/homethree': 'Home Style 3',
};

export default function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    const title = ROUTE_NAMES[path] || 'Huqup - Cafe & Grill';
    analytics.trackPageView(path, `${title} | Huqup - Cafe & Grill`);
  }, [location.pathname]);
}
